// Status chip colors
export const statusColors: Record<string, "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"> = {
  new: 'default',
  planned: 'primary',
  'in-progress': 'secondary',
  completed: 'success',
  declined: 'error'
};